// extracted by mini-css-extract-plugin
export default {"LoadError":"bfb_a bho_qs bho_a bho_w bho_j bho_q","LoadError__icon":"bfb_b bho_vl bho_fm bho_sw","LoadError__message":"bfb_c bho_fm bho_tr"};